import {Params} from '../getConfig'

export const amplifyNovaairProduction: Params = {
  aws_user_pools_id: 'eu-west-1_cuhHxsVXh',
  aws_cognito_identity_pool_id: '', // Not needed for any partner
  aws_user_pools_web_client_id: '3v0gg32d8lvoshtqqfhlghfjve',
  oauth_domain: 'novaair-auth-production.auth.eu-west-1.amazoncognito.com',
  aws_user_files_s3_bucket: '' // Not needed for any partner
}
